import { render, staticRenderFns } from "./ActionCopy.vue?vue&type=template&id=fc9d116e&scoped=true&"
import script from "./ActionCopy.vue?vue&type=script&lang=js&"
export * from "./ActionCopy.vue?vue&type=script&lang=js&"
import style0 from "./ActionCopy.vue?vue&type=style&index=0&id=fc9d116e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9d116e",
  null
  
)

export default component.exports